//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getUserInfo, isApp, callApp} from '@/util/const'
import {setAuthorization} from '@/axios/userInfo'

export default {
    name: "UDI",
    data() {
        return {
            lang: '',
            userInfo: null,
            isShow: false,
            vShow: false,
            userType: null,
            version: ''
        }
    },
    methods: {
        callCar() {
            if (this.userType === 4) {
                this.isShow = true
                return
            }
            if (this.version < 780) {
                this.vShow = true
                return;
            }
            window.location.href = 'cmcchkhsh://callCarPassenger'
        },
        close() {
            window.location.href = 'cmcchkh5action://close'
        },
        update(){
            window.location.href = `http://mylink.komect.com/mylink/#/l/?link=`
        },
    },

    created() {
        this.lang = window.localStorage.lang
        if (!isApp()) {
            let url = encodeURIComponent(`${window.location.origin}/activity/mylinkActivity/#/UDI`)
            window.location.href = `http://mylink.komect.com/mylink/#/l/?link=${url}`
            return;
        }
        let that = this
        window.getUserInfo = (obj) => {
            if (obj) {
                setAuthorization(obj.authorization)
                that.userType = obj.user.userType
            }
        }
        getUserInfo({callbackName: 'getUserInfo', needLogin: true})
        let u = navigator.userAgent
        let v = u.substring(u.length - 5)
        let v2 = v.replace(/\./g, '')
        this.version = v2
    }
}



// WEBPACK FOOTER //
// ./src/page/UDI.vue